import { useEffect, useState } from "react";
import { Badge, Dropdown, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import AdminService from "../../../../../services/AdminManagment/AdminService";
import { Translate } from "../../../../Enums/Tranlate";
import DeleteModal from "../../../../common/DeleteModal";

const CardItem = ({ item, index, setShouldUpdate }) => {
	const [status, setStatus] = useState(null);
	const [deleteModal, setDeleteModal] = useState(false);
	const navigate = useNavigate();
	const adminService = new AdminService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);

	useEffect(() => {
		setStatus(!item.isBlocked);
	}, [item]);

	const changeStatusToggle = (e) => {
		let data = {
			isBlocked: status,
		};
		adminService.toggleStatus(item.id, data).then((res) => {
			if (res?.status === 200) {
				toast.success(Translate[lang].updated_status_successfully);
				setStatus(!status);
			}
		});
	};

	return (
		<tr key={index}>
			<td>
				<strong>{item?.id}</strong>
			</td>
			<td>{`${item?.fullName}`}</td>
			<td>{item?.email}</td>
			<td>{item?.phoneNumber || "-"}</td>
			<td>
				<Badge variant="outline-success">{item?.role?.name}</Badge>
			</td>
			<td
				style={{
					cursor: Auth?.admin?.id === item?.id ? "not-allowed" : "pointer",
				}}>
				<Form.Check
					type="switch"
					id={`custom-switch${index}`}
					checked={status}
					style={{
						opacity: Auth?.admin?.id === item?.id ? ".7" : "1",
					}}
					// disabled={!isExist("edit_admin") || Auth?.admin?.id === item?.id}
					onChange={(e) => changeStatusToggle(e)}
				/>
			</td>
			<td>
				{/* {(isExist("delete_admin") || isExist("edit_admin")) && ( */}
				<Dropdown>
					<Dropdown.Toggle className="light sharp i-false">
						<i className="la la-ellipsis-v" style={{ fontSize: "27px" }}></i>
					</Dropdown.Toggle>
					<Dropdown.Menu>
						{/* {isExist("edit_admin") && ( */}
						<Dropdown.Item
							onClick={() =>
								navigate(`/edit-admin/${item.id}/${item?.f_name}`, {
									state: { edit: true, id: item.id, item: item },
								})
							}>
							<i className="la la-edit"></i> {Translate[lang]?.edit}
						</Dropdown.Item>
						{/* )} */}
						{/* {isExist("delete_admin") && ( */}
						<Dropdown.Item onClick={() => setDeleteModal(true)}>
							<i className="la la-trash"></i> {Translate[lang]?.delete}
						</Dropdown.Item>
						{/* )} */}
					</Dropdown.Menu>
				</Dropdown>
				{/* )} */}
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.fullName}
					deletedItem={item}
					modelService={adminService}
					setShouldUpdate={setShouldUpdate}
					onCloseModal={setDeleteModal}
				/>
			)}
		</tr>
	);
};
export default CardItem;
